export const CONFIRMATION_MODAL = 'CONFIRMATION_MODAL';
export const MULTI_SELECTION_MODAL = 'MULTI_SELECTION_MODAL';
